<template lang="html">
  <v-app class="large-screen__body white">
    <div v-if="loading" class="loader-container">
      <loader></loader>
    </div>
    <div v-else>
      <v-toolbar dark flat>
        <div class="back-button-toolbar">
          <v-btn icon class="toolbar-button" @click="$router.go(-1)">
            <img src="~icons/backIcon/backIcon.png" alt="backIcon">
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text center">
          {{ username }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left style="z-index: 40;">
          <v-btn icon slot="activator" dark>
            <img src="~icons/moreIcon/moreIcon.png" alt="moreIcon">
          </v-btn>
          <v-list>
            <v-list-tile :to="{name: 'UserProfileEdit' }">
              <v-list-tile-title>Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="id" :to="{name: 'MessagePrivateChat', params: { id: id}}">
              <v-list-tile-title>Chat</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$store.dispatch('auth/userLogout', { router: $router })">
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>

      <div class="user__header">
        <div class="">
          <v-avatar v-if="avatar" size="66" class="user__avatar">
            <img :src="avatar" :alt="username">
          </v-avatar>
          <v-avatar v-else size="66" class="primary-background">
            <span class="headline white--text">{{ userInitials }}</span>
          </v-avatar>
        </div>

        <div class="user__ratings">
          <v-icon large v-for="(k, i) in karma" :key="`k${i}`">star</v-icon>
        </div>
      </div>

      <v-tabs grow fixed-tabs centered slot="extension" class="primary-tabs">
        <v-tab :to="{name: 'UserProfile', params: {id: userId }}" style="color: white">
          Profile
        </v-tab>
        <v-tab :to="{name: 'UserVault', params: { id: userId }}" style="color: white">
          Vault
        </v-tab>
      </v-tabs>

      <router-view :profile="profile"></router-view>
    </div>
  </v-app>
</template>

<script>
import { fetchUserProfile } from '@/api';
import get from 'lodash/get';

import Loader from '@/components/Loader';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      loadingProfile: false,
      profile: {},
    };
  },
  computed: {
    loading() {
      return this.loadingProfile;
    },
    id() {
      return get(this.profile, 'user_data.user_id');
    },
    username() {
      return get(this.profile, 'user_data.username');
    },
    avatar() {
      return get(this.profile, 'user_data.avatar');
    },
    karma() {
      const karma = parseInt(get(this.profile, 'user_data.user_karma', 0), 10);
      return Math.min(karma, 5);
    },
    userInitials() {
      return this.username && this.username.charAt(0);
    },
    userId() {
      return this.$route.params.id || this.$store.getters['auth/userId'];
    },
    ref_task_id() {
      return this.$route.query.ref_task_id;
    },
  },
  methods: {
    fetchUserProfile: async function _fetchUserProfile() {
      this.loadingProfile = true;
      await this.$store.dispatch('auth/getUserId');
      const token = this.$store.getters['auth/userToken'];
      const userId = this.userId;

      try {
        const { data } = await fetchUserProfile(token, userId, { ref_task_id: this.ref_task_id });
        this.loadingProfile = false;
        this.profile = get(data, '[1].data.details', {});
        this.completions = get(data, '[1].data.details.completion_data', []);
      } catch (e) {
        this.loadingProfile = false;
        this.$store.dispatch('auth/setFlashMessage', {
          message: 'Failed to fetch profile information.',
          type: 'error',
        });
      }
    },
  },
  watch: {
    userId() {
      this.fetchUserProfile();
    },
  },
  mounted() {
    this.fetchUserProfile();
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.user__header {
  padding-top: 10px;
  background: $primary;
  border: 0;
  border-color: black;

  padding-bottom: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.user__avatar img {
  border: 3px solid white;
}

.user__ratings {
  margin-top: 10px;
}

.user__ratings i, .task__ratings i {
  color: #ffcb14;
}

.primary-background {
  background: linear-gradient(-90deg, $primary-red, $primary-yello);
}

.toolbar__title {
  margin-left: unset;
}
</style>



// WEBPACK FOOTER //
// src/layouts/UserLayout.vue